import styled from 'styled-components';
import sectionBackground from '@assets/images/bg_speakers_white.png';

export const Root = styled.div`
  background-image: url(${sectionBackground});
  background-size: cover;
  background-position: center;
  padding: 17.3rem 24.5rem 19.3rem 24.5rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 5rem 2rem;
  }
`;

export const Title = styled.h2<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-size: 12.8rem;
  font-weight: 900;
  line-height: 140.8px;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: 9.6rem;
    line-height: 105.6px;
  }
`;

export const SubTitle = styled.h3`
  font-size: 7rem;
  font-weight: 900;
  line-height: 77px;
  color: ${({ theme }) => theme.color.mobilityGrey};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: 5.2rem;
    line-height: 59.8px;
    width: 90%;
  }
`;

export const LinkLabel = styled.p`
  font-size: 2rem;
  font-weight: 800;
  line-height: 28px;
  font-style: normal;
  font-family: Lato;
  white-space: nowrap;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    white-space: wrap;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchIconImg = styled.img`
  position: absolute;
  left: 25px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
`;

export const SearchInput = styled.input`
  border: 1px solid ${({ theme }) => theme.color.strokeGrey};

  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  font-size: ${({ theme }) => theme.fontSize.size18};
  padding: 1.5rem 2rem 1.5rem 5rem;
  color: ${({ theme }) => theme.color.mobilityGrey};
  background-color: ${({ theme }) => theme.color.white};
  width: 100%;
  height: 5.7rem;

  &::placeholder {
    color: ${({ theme }) => theme.color.mobilityGrey};
    opacity: 0.35;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    border-radius: ${({ theme }) => theme.borderRadius.radius10};
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 5rem 0 0 0;
  gap: 5.25rem;
  flex-wrap: wrap;
  width: 100%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    flex-direction: column;
    gap: 5rem;
  }
`;

export const RootWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
`;
export const ErrorImg = styled.img`
  height: auto;
  width: 20vw;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 50%;
  }
`;
